import styled from 'styled-components'

const Container = styled.div`
	background-color: #ffffff;
	width: 500px;
	border-radius: 5px;
	padding: 50px;
	display: flex;
	justify-content: center;
	align-items: center;
	box-shadow: 1px 17px 30px rgba(194, 195, 199, 0.15);
	flex-direction: column;
`

const Form = styled.form`
	width: 100%;
	text-align: center;
`

const PageTitle = styled.h4`
	font-size: 24px;
	font-weight: bold;
	color: #44344f;
	align-self: flex-start;
	margin-bottom: 40px;
`

const Icon = styled.img`
	margin-bottom: 20px;
	height: 80px;
`

export { Container, Form, PageTitle, Icon }
